import axios from 'axios';
import * as Routes from '@/modules/routes';
import showToast from '@/components/common/Toast';
import useSlideShowStore from '@/components/admin/SlideShow/stores/useSlideShowStore';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';

const useUpdateTeacherNotes = () => {
  const updateSlideInStore = useSlideShowContext(state => state.updateSlide);
  const setHasUnsavedChanges = useSlideShowStore(state => state.setHasUnsavedChanges);

  return (id: number, notes: string) => (
    axios
      .patch(Routes.plato_api_slide_path(id), { notes }, { params: { only: ['notes'] } })
      .then(() => {
        updateSlideInStore(id, { notes });
        setHasUnsavedChanges(false);
        showToast('Successfully saved notes', { position: 'top-right' });
      })
      .catch((error) => {
        showToast('Error saving notes', { msgType: 'error', position: 'top-right' });
        throw error;
      })
  );
};

export default useUpdateTeacherNotes;
